export default __webpack_public_path__ + "static/media/facebookDark.b8fa3119.svg";